import React, { memo } from 'react';
import useAuth from 'src/hooks/useAuth';
import SelectLanguage from './SelectLanguage';

interface INavBar {
  title: string;
}

const Navbar: React.FC<INavBar> = ({ title }) => {
  const { isShuster } = useAuth();

  return (
    <nav
      className={`min-h-9 px-4 py-1 shadow-md sm:h-9 sm:py-0 ${
        isShuster ? 'bg-[#676767]' : 'bg-[#94c947]'
      }`}
    >
      <div className="flex flex-col gap-2 py-1 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-x-2 sm:gap-y-2 sm:py-0">
        <div className="min-w-0 w-full sm:flex-1 sm:w-auto">
          <p
            className="break-words text-xl font-bold text-white sm:truncate sm:whitespace-nowrap"
            title={title}
          >
            {title}
          </p>
        </div>
        <div className="w-full shrink-0 sm:w-auto">
          <SelectLanguage />
        </div>
      </div>
    </nav>
  );
};

export default memo(Navbar);
